
import * as defaultImport from "temporal-polyfill";
export * from "temporal-polyfill";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
